import $ from 'jquery';

export const ELEMENT_SELECTOR = '[data-toggle-element-classes]';
export const PLUGIN_NAME = 'ToggleElementClasses';


$(document).ready(() => {
  $(ELEMENT_SELECTOR).each(function () {
    const element = this;
    System.import(/* webpackChunkName: "plugin--toggle-element-classes" */ './plugin')
      .then(() => {
        $(element)[PLUGIN_NAME]();
      });
  });
});



// WEBPACK FOOTER //
// ./project/client/src/core/plugins/jquery__toggle-element-classes/index.js